/* eslint-disable @typescript-eslint/explicit-function-return-type */
import RootStore from './RootStore';
import React from 'react';
import { IListResult, IResult, IUser } from '../global';
import { IComponent } from '../component.d';
import wxuserApi from '../actions/wxuser';
import galleryApi from '../actions/gallery';
import imageApi from '../actions/image';
import luckyApi from '../actions/lucky';
import intl from 'react-intl-universal';
import request from '../utils/request';
import { getPageSameType } from '../utils/util';

import { observable, action, computed } from 'mobx';

import { weixinLoginDialog } from '../utils/dom';
import { observer } from 'mobx-react';
import { isInMiniProgram } from 'utils/mini_program';

export interface IFormat {
  [key: string]: {
    title: string;
    style?: React.CSSProperties;
    id: string;
    list: {
      hash: string;
      id: string;
      galleryid?: string;
      size?: number;
      hidePayedTag?: boolean;
    }[];
    gallery: any;
  };
}
export default class WxUserStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  addVisited = (galleryid: string) => {
    return wxuserApi.visited(galleryid);
  };

  sendLove = ({ id = 0, galleryid = 0, path = '' }) =>
    wxuserApi.sendLove({ id, galleryid, path });
  faceMaybe = (id: number) => wxuserApi.faceMaybe(id);
  faceIsFriend = (personid: number) => {
    if (this.user && !this.user.is_mock) {
      return wxuserApi.faceIsFriend(personid);
    } else {
      return new Promise(resolve => {
        resolve({
          status: 'unfollow'
        });
      });
    }
  };

  @observable visitedGallery = {
    data: [] as any[],
    total: 0
  };

  @observable user = {
    is_mock: true,
    nickname: '',
    openid: '',
    photo: '',
    redirect: '',
    sysinfo: {
      env: 'wechat',
      is_pc: 0,
      web_appid: ''
    }
  } as IUser;

  getVisitedGallery = (page: number = 1) => {
    return wxuserApi.visitedGallery(page).then(
      action((res: IListResult) => {
        if (page == 1) {
          this.visitedGallery.data = res.data;
        } else {
          this.visitedGallery.data = this.visitedGallery.data.concat(res.data);
        }
        this.visitedGallery.total = res.total;
        // 必须返回{total:全部数量， data:全部数据}否则会导致加载更多有效BUG
        return this.visitedGallery;
      })
    );
  };

  @observable loveImages = {
    data: [] as any[],
    total: 0
  };
  @computed get formattedLoveImages() {
    let { data, total } = this.loveImages || ({} as IListResult);
    let result = {} as IFormat;
    data.forEach((it: any) => {
      let { galleryid, url_labeling, galleryname, gallerytime } = it;
      if (!result[galleryid]) {
        result[galleryid] = {
          title: galleryname,
          list: [],
          id: it.id,
          gallery: {
            galleryid: galleryid,
            url_labeling: url_labeling
          }
        };
      }
      result[galleryid].list.push({
        hash: it.path,
        id: it.imageid,
        galleryid: galleryid
      });
    });
    let keys = Object.keys(result);
    keys.sort((a: string, b: string) => {
      if (Number(a) < Number(b)) {
        return 1;
      } else {
        return -1;
      }
    });
    return {
      keys,
      result
    };
  }

  getLoveImages = (page: number = 1) => {
    return wxuserApi.loveImages(page).then(
      action((res: IListResult) => {
        if (page == 1) {
          this.loveImages.data = res.data;
        } else {
          this.loveImages.data = this.loveImages.data.concat(res.data);
        }
        this.loveImages.total = res.total;
        // 必须返回{total:全部数量， data:全部数据}否则会导致加载更多有效BUG

        // 设置一下水印
        let { watermarks } = res;
        if (watermarks && typeof watermarks == 'object') {
          Object.keys(watermarks).forEach(it => {
            if (!!watermarks[it])
              this.rootStore.galleryStore.setWatermarksByKey(
                String(it),
                watermarks[it]
              );
          });
        }

        return this.loveImages;
      })
    );
  };

  @observable luckyList = {
    data: [] as any[],
    total: 0
  };

  getLuckyList(page: number, luckId?: number | string) {
    return luckyApi.myresult(page, luckId).then(
      action((res: any) => {
        if (res && res.code == 200 && res.data) {
          this.luckyList = {
            data: res.data,
            total: res.data.length
          };
        }
        return this.luckyList;
      })
    );
  }

  @observable inviteUserList = {
    data: [] as any[],
    total: 0
  };

  getInviteUserList(page: number, pageSize?: number) {
    return wxuserApi.inviteUsers(page, pageSize, window.gallery.id).then(action((res: any) => {
      if (res && res.code == 200 && res.data) {
        const { total, items } = res.data;
        if (page == 1) {
          this.inviteUserList = {
            data: (items || []).map((it: any, index: number) => {
              it.rate = index + 1;
              return it
            }),
            total: total
          };
        } else {
          this.inviteUserList = {
            total: total,
            data: this.inviteUserList.data.concat(items).map((it: any, index: number) => {
              it.rate = index + 1;
              return it
            })
          };
        }
      }
    }))
  }

  @observable payedImages = {
    data: [] as any[],
    total: 0
  }

  @computed get formattedPayedImages() {
    let { data, total } = this.payedImages || ({} as IListResult);
    let result = {} as IFormat;
    data.forEach((it: any) => {
      let { galleryid, url_labeling, galleryname, gallerytime } = it;
      if (!result[galleryid]) {
        result[galleryid] = {
          title: galleryname,
          list: [],
          id: it.id,
          gallery: {
            galleryid: galleryid,
            url_labeling: it.url_labeling
          }
        };
      }
      result[galleryid].list.push({
        hash: it.path,
        id: it.id,
        hidePayedTag: true
      });
    });
    let keys = Object.keys(result);
    keys.sort((a: string, b: string) => {
      if (Number(a) < Number(b)) {
        return 1;
      } else {
        return -1;
      }
    });
    return {
      keys,
      result
    };
  }

  getPayedImages = (page: number = 1) => {
    return wxuserApi.payedImages(page).then(
      action((res: IListResult) => {
        if (page == 1) {
          this.payedImages.data = res.data;
        } else {
          this.payedImages.data = this.payedImages.data.concat(res.data);
        }
        this.payedImages.total = res.total;
        // 必须返回{total:全部数量， data:全部数据}否则会导致加载更多有效BUG

        // 设置一下水印
        let { watermarks } = res;
        if (watermarks && typeof watermarks == 'object') {
          Object.keys(watermarks).forEach(it => {
            if (!!watermarks[it])
              this.rootStore.galleryStore.setWatermarksByKey(
                String(it),
                watermarks[it]
              );
          });
        }

        return this.payedImages;
      })
    );
  };

  @observable spliceImages = {
    data: [] as any[],
    total: 0
  };

  @computed get formattedSpliceImages() {
    let { data, total } = this.spliceImages || ({} as IListResult);
    let result = {} as IFormat;
    data.forEach((it: any) => {
      let { galleryid, url_labeling, galleryname, gallerytime } = it;
      if (!result[galleryid]) {
        result[galleryid] = {
          title: galleryname,
          list: [],
          id: it.id,
          gallery: {
            galleryid: galleryid,
            url_labeling: it.url_labeling
          }
        };
      }
      result[galleryid].list.push({
        hash: it.thumb,
        id: it.id
      });
    });
    let keys = Object.keys(result);
    keys.sort((a: string, b: string) => {
      if (Number(a) < Number(b)) {
        return 1;
      } else {
        return -1;
      }
    });
    return {
      keys,
      result
    };
  }

  getSpliceImages = (page: number = 1) => {
    return wxuserApi.spliceImages(page).then(
      action((res: IListResult) => {
        if (page == 1) {
          this.spliceImages.data = res.data;
        } else {
          this.spliceImages.data = this.spliceImages.data.concat(res.data);
        }
        this.spliceImages.total = res.total;
        // 必须返回{total:全部数量， data:全部数据}否则会导致加载更多有效BUG

        // 设置一下水印
        let { watermarks } = res;
        if (watermarks && typeof watermarks == 'object') {
          Object.keys(watermarks).forEach(it => {
            if (!!watermarks[it])
              this.rootStore.galleryStore.setWatermarksByKey(
                String(it),
                watermarks[it]
              );
          });
        }

        return this.spliceImages;
      })
    );
  };

  // setRecentGallery = (galleryid: string | number, image: string) => {
  //   if (!!galleryid) {
  //     window.localStorage.setItem('last_gallery', String(galleryid));
  //     window.localStorage.setItem(
  //       'last_gallery_photo',
  //       String(image || 'static/share_logo_0324.jpg')
  //     );
  //   }
  // };
  setRecentGallery = (data: any) => {
    window.localStorage.setItem(`lastVisit`, JSON.stringify(data));
  }

  getRecentGallery = async () => {
    const lastVisit = window.localStorage.getItem(`lastVisit`) || "";

    let result = null as any;
    try {
      const visit = JSON.parse(lastVisit);
      if (visit && visit.title && visit.url && visit.image) {
        result = visit as any;
      }
    } catch (e) {
      // nothing to do
    }

    if (!result) {
      const rpc = await wxuserApi.getLastVisit();
      if (rpc && rpc.data && (rpc.data.url_labeling || rpc.data.link_id)) {
        result = Object.assign(rpc.data, {
          url: window.location.protocol + '//' + window.__hostname + (rpc.data.url_labeling ? '/gti/' + rpc.data.url_labeling : '/g/' + rpc.data.link_id)
        });
      }
    }

    return result;
  }

  like = (galleryid = '', imageid = '') => {
    return wxuserApi.like(galleryid, imageid);
  };
  ocr = (
    keyword: string,
    galleryid?: number | string,
    galleryIds: Array<number | string> = [],
    matchMode: 'exact' | 'fuzzy' = 'fuzzy'
  ) => {
    return imageApi.ocr(keyword, galleryid, galleryIds, matchMode).then(
      action((res: any) => {
        let images = res
          .filter((it: any) => !!it.image)
          .map((one: any) => {
            const currentImage = one.image || {};
            const normalizedGalleryId =
              one.galleryid ||
              one.gallery_id ||
              currentImage.galleryid ||
              currentImage.gallery_id;

            return {
              ...one,
              id: currentImage.id || one.imageid || one.id,
              imageid: one.imageid || currentImage.id || one.id,
              hash: currentImage.hash || one.hash,
              size: currentImage.size,
              origin: currentImage.origin,
              width: currentImage.width,
              height: currentImage.height,
              galleryid: normalizedGalleryId,
              gallery_id: normalizedGalleryId,
              show_mark: Number(currentImage.show_mark),
              trash: Number(currentImage.trash),
              check: Number(currentImage.check),
            };
          });

        res.forEach((it: any) => {
          const currentGalleryId = it.galleryid || it.gallery_id;
          if (currentGalleryId && it.gallery && it.gallery.watermarks) {
            this.rootStore.galleryStore.setWatermarksByKey(
              String(currentGalleryId),
              it.gallery.watermarks
            );
          }
        });

        return images;
      })
    );
  };
  aiSearch = async ({
    orderId,
    galleryIds,
    useOcr = 0,
    queryText,
    imageBase64,
    threshould = 1.65,
  }: {
    orderId: string | number;
    galleryIds?: Array<string | number>;
    useOcr?: 0 | 1;
    queryText?: string;
    imageBase64?: string;
    threshould?: number | string;
  }) => {
    const res: any = await imageApi.aiSearch({
      orderId,
      gallery_ids: galleryIds,
      use_ocr: useOcr,
      threshould,
      query_text: queryText,
      image_base64: imageBase64,
    });

    const rawList = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res)
        ? res
        : [];

    const imageIds = rawList
      .map((item: any) => item && item.id)
      .filter(Boolean);

    let detailMap = {} as {
      [key: string]: any;
    };

    if (imageIds.length) {
      try {
        const detailRes: any = await imageApi.getImageById(imageIds);
        if (detailRes && detailRes.watermarks) {
          Object.keys(detailRes.watermarks).forEach((currentGalleryId) => {
            const marks = detailRes.watermarks[currentGalleryId];
            this.rootStore.galleryStore.setWatermarksByKey(
              String(currentGalleryId),
              marks
            );
          });
        }
        const detailList = Array.isArray(detailRes?.data)
          ? detailRes.data
          : Array.isArray(detailRes)
            ? detailRes
            : [];
        detailMap = detailList.reduce((result: any, item: any) => {
          if (item && item.id) {
            result[String(item.id)] = item;
          }
          return result;
        }, {});
      } catch (error) {
        console.warn('[aiSearch] 图片详情补全失败', error);
      }
    }

    return action(() => {
      return rawList
        .filter((item: any) => item && item.id)
        .filter((item: any) => Number(item.score || 0) <= Number(threshould))
        .map((item: any) => {
          const detail = detailMap[String(item.id)] || {};
          const normalizedGalleryId =
            item.galleryid ||
            item.gallery_id ||
            detail.galleryid ||
            detail.gallery_id;

          return {
            ...item,
            id: item.id,
            imageid: item.imageid || item.id,
            hash: item.hash || detail.hash || detail.path,
            size: detail.size,
            origin: detail.origin,
            width: detail.width,
            height: detail.height,
            galleryid: normalizedGalleryId,
            gallery_id: normalizedGalleryId,
            show_mark:
              typeof detail.show_mark !== 'undefined'
                ? Number(detail.show_mark)
                : 1,
            trash: Number(detail.trash || 0),
            check: Number(detail.check || 0),
            score: Number(item.score || 0),
          };
        })
        .filter((item: any) => !!item.hash);
    })();
  };
  unfollow = (id: any) => {
    // this.rootStore!.uiStore.showToast({ content: '取消关注成功' });
    return wxuserApi.faceUnfollow({
      personid: id
    }).then(action(() => {
      let person = this.rootStore!.relationStore.person;
      if (person && person.id == id) {
        this.rootStore!.relationStore.person = {
          ...person,
          status: 'unfollow'
        };
      }
    }));
  };
  follow = (params: any) => {
    return wxuserApi.faceFollow(params).then(action(() => {
      let person = this.rootStore!.relationStore.person;
      if (person && person.id == params.personid) {
        this.rootStore!.relationStore.person = {
          ...person,
          status: 'follow'
        };
      }
    }));
  };

  destoryMyself = () => {
    return wxuserApi.faceDestroyInfo().then(action(() => {
      this.rootStore!.relationStore.clearMyself();
    }));
  }

  findPeople = (params: any) => {
    return wxuserApi.findPeople(params);
  };

  sessionTimer = 0 as any;

  session = () => {
    return wxuserApi.session().then(
      action((res: any) => {
        let { code, data } = res;
        if (data && data.user) {
          let temp = {
            ...data.user,
            redirect: ''
          };

          if (temp.is_mock == 'false') {
            temp.is_mock = false;
          }

          if (data.sysinfo) {
            temp.sysinfo = data.sysinfo;

            if (temp.sysinfo) {
              this.rootStore.redPackStore.setServerTime(temp.sysinfo.srv_time);
            }
          }

          if (code == 200302) {
            temp.redirect = data.redirect;
          }

          this.user = temp;
        }

        if (!this.user.is_mock) {
          // 过期时间内，还要继续请求一次session
          clearTimeout(this.sessionTimer);
          this.sessionTimer = setTimeout(this.session, (3600 - 60) * 1000);
          request.token = data.token;
        } else {
          let { sysinfo } = this.user;

          const isEmbeddedExhibitorForm =
            new URLSearchParams(window.location.search).get('embedded_exhibitor_form') === '1';
          if (!isEmbeddedExhibitorForm && Number(window.configDetail.active_on)) {
            if (sysinfo.env && sysinfo.env.toLowerCase() == 'wechat' && !sysinfo.is_pc) {
              // 如果是引导页的话，可以尝试不弹窗出来
              let flag = true;
              let guide = getPageSameType(window.pageDetail.template, [], ['guide']) as IComponent[];
              if (guide && guide.length) {
                let oneComp = guide[0];
                // @ts-ignore
                if (oneComp && oneComp.autoPlay === true) {
                  flag = false;
                }
              }
              // 如果当前页已经弹出过一次了，则不再提示
              if (!!Number(window.sessionStorage.getItem('weixin_auth'))) {
                flag = false;
              }
              // 如果当前小程序的话，不要默认弹窗
              const isMiniProgram = isInMiniProgram();
              if (isMiniProgram) {
                flag = false;
              }

              if (flag) {
                this.auth();
                window.sessionStorage.setItem('weixin_auth', "1");
              }
            }
          }
        }

        window.userinfo = this.user;

        return this.user;
      })
    );
  };

  auth = (hideClose: boolean = false) => {
    if (
      this.user &&
      this.user.is_mock &&
      Number(window.configDetail.active_on)
    ) {
      let { sysinfo } = this.user;
      // 如果是PC端访问的话，则使用弹窗二维码登录
      if (!!+sysinfo.is_pc) {
        // 此处应该弹框处理
        weixinLoginDialog(
          this.user.openid,
          this.user.redirect,
          hideClose,
          this.user.sysinfo.web_appid
        );
      } else {
        this.rootStore.uiStore.showBasicDialog({
          title: '微信授权',
          content: '网页浏览需获取您的公开信息（昵称、头像等）',
          showCancel: true,
          cancelText: intl.get('cancel'),
          onCancel: () => {
            this.rootStore.uiStore.hideBasicDialog();
          },
          okText: intl.get('ok'),
          onOk: () => {
            // alert('去授权了');
            window.location.href = this.user.redirect;
          }
        })
        // window.location.href = this.user.redirect;
        // 如果是微信环境，则先行弹出确认授权按钮，如果同意的话，就跳转链接
        // weixinAuthDialog({
        //   hideClose,
        //   onCancel:()=>{
        //
        //   },
        //   onSubmit:()=>{
        //     window.location.href = this.user.redirect;
        //   }
        // })
      }
    }
  };

  @observable payedList = {
    data: [] as any[],
    total: 0
  };

  getPayedList = (page: number = 1) => {
    return wxuserApi.payedImages(page).then(
      action((res: IListResult) => {
        if (page == 1) {
          this.payedList.data = res.data;
        } else {
          this.payedList.data = this.payedList.data.concat(res.data);
        }
        this.payedList.total = res.total;

        // 设置一下水印
        let { watermarks } = res;
        if (watermarks && typeof watermarks == 'object') {
          Object.keys(watermarks).forEach(it => {
            if (!!watermarks[it])
              this.rootStore.galleryStore.setWatermarksByKey(
                String(it),
                watermarks[it]
              );
          });
        }

        return this.payedList;
      })
    );
  };

  @observable currentPayGood = {} as {
    [key: string]: any
  };
  getCurrentPayGood = (good_id: string | number) => {
    return this.rootStore.pagedataStore!.getPayGood(good_id).then(action((res: IResult) => {
      this.currentPayGood = {
        ...this.currentPayGood,
        [String(good_id)]: res
      };
    }));
  }

  @observable currentPayedImages = {} as {
    [key: string]: boolean
  };

  @action setCurrentPayedImages = (image_id: number | string, value: boolean) => {
    this.currentPayedImages = {
      ...this.currentPayedImages,
      [String(image_id)]: value
    };
  }

  @observable notNeedToPay = {} as {
    [key: string]: boolean
  };

  @action setNotNeedToPay = (image_id: number | string, value: boolean) => {
    this.notNeedToPay = {
      ...this.notNeedToPay,
      [String(image_id)]: value
    };
  }

  getNotPayed = (imgids: number[]) => {
    return imgids.filter((id: number) => {
      if (this.currentPayedImages && this.currentPayedImages[String(id)]) {
        return null;
      }
      if (this.notNeedToPay && this.notNeedToPay[String(id)]) {
        return null;
      }
      return true;
    });
  };

  getCurrentPayedImages = (gallery_id: string | number) => {
    if (this.user.is_mock) {
      return this.currentPayedImages;
    }
    return wxuserApi.currentPayedImages(gallery_id).then(action((res: any) => {
      if (res && res.code == 200 && res.data && res.data.items && res.data.items.length) {
        res.data.items.map((it: any) => {
          if (it && it.image_id) {
            this.currentPayedImages = {
              ...this.currentPayedImages,
              [String(it.image_id)]: true
            };
          }

          return null;
        });
      }

      return this.currentPayedImages;
    }));
  };
  // /api/v2/pay/getdownimglist

  payToImage = (gallery_id: string | number, goods_id: string | number, link_id: string, imgids: number[]) => {
    return wxuserApi.payToImage(gallery_id, goods_id, link_id, imgids).then(jsonData => {
      if (
        jsonData &&
        jsonData.code == 200 &&
        jsonData.data &&
        jsonData.data.id
      ) {
        // 一切正常，直接去支付
        return this.rootStore.pagedataStore!.doPay(jsonData.data, {
          mainTitle: `当前相册开启了照片付费功能，请用微信扫描下方二维码支付，付费完成后 ，请点击下方“已支付完成”`
        }).then(res => {
          if (!!res) {
            // 需要刷新一下
            const currentGallery = window.dataDetail ? window.dataDetail : window.gallery;
            if (currentGallery && currentGallery.id == gallery_id) {
              this.getCurrentPayedImages(gallery_id);
            }
          }

          return jsonData;
        });
      }
      else if (jsonData && jsonData.code == 200201) {
        // 有一些照片实际上已经支持完成了的
        // this.currentPayedImages = (jsonData.data || []).concat(this.currentPayedImages);
        (jsonData.data || []).map(action((it: any) => {
          if (it) {
            this.setCurrentPayedImages(String(it), true);
          }
        }));
        return jsonData;
      }
      else {
        return jsonData;
      }
    });
  };
}
